export default __webpack_public_path__ + "static/media/pj-jogo-dinossauro.4820a95c.png";